
import Assert from "tbAssert";
import StatusClassServiceModule from "../../../services/StatusClassService";

const mStatusClassSvc = new WeakMap();

const mEventData = new WeakMap();
const mEditorNavigateFn = new WeakMap();
const mEventSelected = new WeakMap();

const mTooltipIsOpen = new WeakMap();
const mEnableTooltip = new WeakMap();

const mEventTextClass = new WeakMap();

class CalendarEventController {
    constructor(StatusClass) {
        Assert.StrictAssert(StatusClass != null, "Assertion Failure: Missing Status Class Service Dependency");

        mStatusClassSvc.set(this, StatusClass);

        mTooltipIsOpen.set(this, false);
        mEnableTooltip.set(this, true);
    }

    get eventData() {
        return mEventData.get(this);
    }

    set eventData(updatedVal) {
        mEventData.set(this, updatedVal);
    }

    get editorNavigateFn() {
        return mEditorNavigateFn.get(this);
    }

    set editorNavigateFn(updatedVal) {
        mEditorNavigateFn.set(this, updatedVal);
    }

    get eventSelected() {
        return mEventSelected.get(this);
    }

    set eventSelected(updatedVal) {
        mEventSelected.set(this, updatedVal);
    }

    get eventDisplayTitle() {
        return mEventData.get(this).displayTitle;
    }

    get eventStatusName() {
        return mEventData.get(this).statusName;
    }

    get eventStatusClass() {
        return mStatusClassSvc.get(this).getClassForStatus(mEventData.get(this).statusName);
    }

    get eventLocationStateName() {
        return  mEventData.get(this).locationStateName;
    }

    get eventTextClass() {
        return mEventTextClass.get(this);
    }

    set eventTextClass(updatedVal) {
        mEventTextClass.set(this, updatedVal);
    }

    get tooltipIsOpen() {
        return mTooltipIsOpen.get(this);
    }

    set tooltipIsOpen(updatedVal) {
        mTooltipIsOpen.set(this, updatedVal);
    }

    get enableTooltip() {
        return mEnableTooltip.get(this);
    }

    // Methods
    openEventPopup(e) {
        if (e != null) {
            e.preventDefault();
        }

        mTooltipIsOpen.set(this, false);
        let currentEvent = this.eventData;
        this.eventSelected({evt: currentEvent});
    }

    openEventTooltip(e) {
        if (e != null) {
            e.preventDefault();
        }

        mTooltipIsOpen.set(this, true);
    }

    closeEventTooltip(e) {
        if (e != null) {
            e.preventDefault();
        }

        mTooltipIsOpen.set(this, false);
    }

    goToEventEditor(e) {
        if (e != null) {
            e.preventDefault();
        }
        let trackingEventId = this.eventData.trackingEventId;
        this.editorNavigateFn({eventId: trackingEventId});
    }
}

CalendarEventController.$inject = [ "StatusClass" ];

CalendarEventController.dependencies = [
    "ngSanitize",
    "ngAnimate",
    "ui.bootstrap",
    StatusClassServiceModule
];

CalendarEventController.controllerAs = "calendarEvent";

export default CalendarEventController;




//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/calendar-event/CalendarEventController.js
// module id = OEHV
// module chunks = 1